<ds-register-email-form
    [MESSAGE_PREFIX]="'forgot-email.form'">
</ds-register-email-form>